 <!-- <div class="card" style="border-radius: 24px; background: linear-gradient(180deg, #484848 0%, #0D0D0D 100%);">
  <div class="card-body">
    <h5 class="card-title" style="line-height: 1.25;">
      Let us help you to run your business Smoothly
    </h5>

    <h6 class="card-subtitle"  style="line-height:1.25;color: white;">
      We have great payment solutions for you, which
      <p>help you to grow your business.</p>
    </h6>
    <div class="content">

      <div *ngFor="let item of items" class="flex-container" style=" font-size: 14px; font-weight: 400; margin-bottom: 3px; margin-top: -10px;">
        <img src="{{ item.src }}" alt="Logo" style="width: 32px; height: 32px;  margin-top: 13px;"
          class="img-fluid logo mb-3">
          <label class="text" style="flex-grow: 1;line-height: 1.5;color:var(--white)">{{ item.text }}</label>
      </div>
    </div>
    Image at the bottom-right corner
    <img *ngIf="showSalyLogo" class="salyLogo" src="assets/dashboard/pay_profile/Saly-1.png" alt="Bottom Right Image">
  </div>
</div> -->


<div class="card" style="border-radius: 24px; background: linear-gradient(180deg, #484848 0%, #0D0D0D 100%); height: 90%;">
  <div class="card-body">
    <h5 class="card-title" style="line-height: 1.25;">
      Let us help you to run your business Smoothly
    </h5>

    <h6 class="card-subtitle"  style="line-height:1.25;padding-right: 40px;">
      We have great payment solutions for you, which will
      help you to grow your business.
    </h6>
    <div class="content">
      <div *ngFor="let item of items" class="flex-container" style="color:var(--white); font-size: 14px; font-weight: 400; margin-bottom: 3px; margin-top: -10px;">
        <img src="{{ item.src }}" alt="Logo" style="width: 32px; height: 32px;  margin-top: 13px;"
          class="img-fluid logo mb-3">
          <span style="flex-grow: 1;line-height: 1.5;color:var(--white)">{{ item.text }}</span>
      </div>
    </div>
    <!-- Image at the bottom-right corner -->
    <img *ngIf="showSalyLogo" class="salyLogo" src="assets/img/Saly-1.png" alt="Bottom Right Image">
  </div>
</div>
